export default __webpack_public_path__ + "static/media/img2.4012a7be.jpg";